import { alpha, Stack, Typography } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import { Colors, SPACING } from 'shared/constants/AppEnums'

export const HeaderSeparator = ({ title, type = 'primary' }) => {
    return (
        <Stack width={'100%'} direction={'row'} height={50} alignItems={'center'} gap={2}>
            <Stack height={'100%'} width={20} bgcolor={Colors[type]} sx={{ borderTopRightRadius: 10, borderBottomRightRadius: 10 }}></Stack>
            <Stack height={'100%'} width={'100%'} bgcolor={alpha(Colors[type], 0.15)} sx={{ borderTopLeftRadius: 10, borderBottomLeftRadius: 10 }} direction={'row'} alignItems={'center'} px={SPACING / 2}>
                <Typography variant='h4' fontWeight={'bold'}>{title}</Typography>
            </Stack>
        </Stack>
    )
}

HeaderSeparator.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string
}